<template>
<v-app>

<div
    class="app_bar"
    v-bind:class="{ 'app_bar' : true, 'app_bar_with_org_name' : value != null }"
>
    <img 
            src="@/assets/sanderson-logo.png" 
            class="img"
        />
</div>

  <v-main>
    <v-container>
        
        <v-form
            v-model="valid"
            autocomplete="off"
            
        >

        <v-text-field
            label="First Name"
            v-model="first_name"
            autocomplete="nope"
            data-lpignore="true"
            autofocus
        />

        <v-text-field
            label="Last Name"
            v-model="last_name"
            autocomplete="nope"
            data-lpignore="true"
        />

        <v-text-field
            label="Cell Phone Number *"
            :rules="[rules.cell]"
            v-model="cell"
            autocomplete="nope"
            data-lpignore="true"
        />

        <v-text-field
            label="Email"
            v-model="email"
            autocomplete="nope"
            data-lpignore="true"
        />

        <v-text-field
            label="Zip Code"
            v-model="zip_code"
            autocomplete="nope"
            data-lpignore="true"
        />

        <v-text-field
            label="Which Lincoln(s) are you interested in?"
            v-model="interested_in"
            autocomplete="nope"
            data-lpignore="true"
        />

        <v-select
            label="Who Were You Assisted By Today"
            :items="['No one','Angela Rojo','Brian Shulda','David Fabian', 'Dayton Saunders', 'Greg Bernave ', 'Jazmine Sprenger','Jonathan Gaspar','Leslie Belin','Lynnsey Coppinger','Madison Wayne ', 'Megan Agrusa','Nathan Finney','Wilbert Schouten']"
            v-model="who_assisted"
        />

        <v-checkbox
            label="Would you like to do a test drive?"
            v-model="cb_values"
            value="test-drive"
        />

        <v-checkbox
            label="Would you like more information on Black Label?"
            v-model="cb_values"
            value="black-label"
        />

        <v-checkbox
            label="Would you like to receive more information about Sanderson Lincoln Special Events?"
            v-model="cb_values"
            value="more-info"
            style="margin-bottom: 15px;"
        />

        <v-btn
            color="secondary"
            style="margin-right: 15px"
            :disabled="!valid"
            v-on:click="onClickSubmit"
        >
            Submit
        </v-btn>

        <v-btn
            v-on:click="onClickReset"
        >
            Reset
        </v-btn>

        </v-form>

    </v-container>
  </v-main>

  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>

const E164 = require('@/js/E164.js');
const axios = require('axios');

export default {

    data() {
        return {
            first_name: null,
            last_name: null,
            cell: null,
            email: null,
            zip_code: null,
            interested_in: null,
            cb_values: [],
            valid: false,
            who_assisted: 'No one',

            rules: {
                required: (value) => { if ( value == null || value.trim().length == 0 ) return 'Required'; return true; },
                state: (value) => { if ( value == null || value.trim().length < 2 ) return 'Two letter minimum'; return true;  },
                country: (value) => { if ( value == null || value.trim().length < 2 ) return 'Three letter minimum'; return true; },
                zip: (value) => { if ( value == null || value.trim().length < 5 ) return 'Five letter minimum'; return true; },
                cell: (value) => { if ( value == null || !E164.isUSPhoneNumber(value) ) return 'Enter a valid phone number'; return true; },
            },
        }
    },


    methods: {

        onClickReset()
        {
            if(window.confirm("Clear the form?"))
            {
                this.resetForm();
            }
        },

        resetForm()
        {
            this.first_name = null;
            this.last_name = null;
            this.cell = null;
            this.email = null;
            this.zip_code = null;
            this.interested_in = null;
            this.cb_values = [];
            this.who_assisted = 'No one';
        },

        createRequest()
        {
            return {
				'first_name' : this.first_name,
				'last_name' : this.last_name,
				'mobile' : this.cell,
				'submitted_from_url' : window.location.href,
                'production': true,

				'extra_fields' : [
					{ 'text' : 'Email', 'value' : this.email },
					{ 'text' : 'Zip Code', 'value' : this.zip_code },
					{ 'text' : 'Interested In', 'value' : this.interested_in },
					{ 'text' : 'Test drive', 'value' : this.cb_values.includes('test-drive') ? 'Yes' : 'No' },
					{ 'text' : 'Black Label', 'value' : this.cb_values.includes('black-label') ? 'Yes' : 'No' },
                    { 'text' : 'More Info', 'value' : this.cb_values.includes('more-info') ? 'Yes' : 'No' },
                    { 'text' : 'Who Assisted', 'value' : this.who_assisted },
				],
			};
        },

        onClickSubmit()
        {
            let axios_data = JSON.stringify(this.createRequest());
            let axios_headers = {'Content-type':'application/json; charset=UTF-8'};

            let axios_request = {
                'url' : ' https://app.redchirp.com/api/v1/contact-requests/form-connect/8f66d598-75ed-49d3-aa15-daeb09463571/16b86b3f-0301-4c9f-911d-e9e6301e8455',
                'method' : 'post',
                'data' : axios_data,
                'headers' : axios_headers,
                'timeout' : 15000, 
            };

            axios.request(axios_request)
            .then( ({ data }) => {
                alert('Form submitted!');
                this.resetForm();
            })
            .catch((err) => 
                {
                    alert('unable to save form');
                }
            );
        }
        
    },

    computed: {
        request() {
            return this.createRequest(); 
        }
    },
}
</script>

<style lang="scss" scoped>

.app_bar {
    width: 100%;
    height: 180px;
    background-color: #efefef;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 15px;
}

</style>


            
           